import forDevice from '../../hoc/for-device';
import ReviewMobile from './review-mobile';
import ReviewDesktop from './review-desktop';

export const Review = forDevice(ReviewMobile, ReviewDesktop);
